<script>
import * as THREE from 'three';
import _debounce from 'lodash/debounce';

let placeholderNode;
let hasInit = false;
let hasRendered = false;
export let color1 = [66, 134, 244];
export let color2 = [55, 66, 250];
const hasBackgroundPage = window.parent !== window;

function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function rgb(r, g, b) {
    return new THREE.Vector3(r, g, b);
}
$: if (placeholderNode && !hasInit) {
    initAnimation();
    hasInit = true;
}
// document.addEventListener("DOMContentLoaded", initAnimation);
function initAnimation() {
    const renderer = new THREE.WebGLRenderer({antialias: true});
    // document.body.insertBefore( renderer.domElement, document.body.children[0] )
    placeholderNode.parentNode.replaceChild(renderer.domElement, placeholderNode);

    const scene = new THREE.Scene();
    // scene.background = new THREE.Color( 0x4286f4 );
    scene.background = new THREE.Color( color1[0]*256*256 + color1[1]*256 + color1[2] );
    const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );

    let vCheck = false;

    camera.position.z = 5;

    var randomisePosition = new THREE.Vector2(1, 2);

    var R = function(x, y, t) {
        return( Math.floor(192 + 64*Math.cos( (x*x-y*y)/300 + t )) );
    }

    var G = function(x, y, t) {
        return( Math.floor(192 + 64*Math.sin( (x*x*Math.cos(t/4)+y*y*Math.sin(t/3))/300 ) ) );
    }

    var B = function(x, y, t) {
        return( Math.floor(192 + 64*Math.sin( 5*Math.sin(t/9) + ((x-100)*(x-100)+(y-100)*(y-100))/1100) ));
    }
    let sNoise = document.querySelector('#snoise-function').textContent;
    const referenceWidth = 600;
    let geometry = new THREE.PlaneGeometry(referenceWidth, 400, 100, 100);
    let material = new THREE.ShaderMaterial({
        uniforms: {
            // u_bg: {type: 'v3', value: rgb(162, 138, 241)}, // Original from codepen
            // u_bg: {type: 'v3', value: rgb(0, 16, 96)}, // LeadAction Dark Slate
            u_bg: {type: 'v3', value: rgb(...color1)}, // LeadAction blue
            u_bgMain: {type: 'v3', value: rgb(...color2)}, // Bright Greek from flatuicolors.com
            u_color1: {type: 'v3', value: rgb(...color1)}, // LeadAction blue
            // u_color2: {type: 'v3', value: rgb(82, 31, 241)}, // Original from codepen
            u_color2: {type: 'v3', value: rgb(...color2)}, // Bright Greek from flatuicolors.com
            u_time: {type: 'f', value: 0},
            u_randomisePosition: { type: 'v2', value: randomisePosition }
        },
        fragmentShader: sNoise + document.querySelector('#fragment-shader').textContent,
        vertexShader: sNoise + document.querySelector('#vertex-shader').textContent,
    });

    let mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(0, 140, -280);
    mesh.rotationX = -1.0;
    mesh.rotationY = 0.0;
    mesh.rotationZ = 0.1;
    scene.add(mesh);

    // renderer.render( scene, camera );

    let t = 0;
    let j = 0;
    let x = randomInteger(0, 32);
    let y = randomInteger(0, 32);
    let needsResize = true;
    const resize = function() {
        mesh.scale.set( window.innerWidth / 2 / referenceWidth, 1, 1 );
        mesh.scale.multiplyScalar(5);
        renderer.setSize( window.innerWidth, window.innerHeight );
        camera.aspect = window.innerWidth / window.innerHeight;
    }
    const animate = function () {
        requestAnimationFrame( animate );
        if (needsResize) {
            resize();
            needsResize = false;
        }
        renderer.render( scene, camera );
        hasRendered = true;
        mesh.material.uniforms.u_randomisePosition.value = new THREE.Vector2(j, j);

        mesh.material.uniforms.u_color1.value = new THREE.Vector3(R(x,y,t/2), G(x,y,t/2), B(x,y,t/2));

        mesh.material.uniforms.u_time.value = t;
        if(t % 0.1 == 0) {
            if(vCheck == false) {
                x -= 1;
                if(x <= 0) {
                    vCheck = true;
                }
            } else {
                x += 1;
                if(x >= 32) {
                    vCheck = false;
                }

            }
        }

        // Increase t by a certain value every frame
        j = j + 0.01;
        t = t + 0.05;
    };
    if (hasBackgroundPage) {
        requestAnimationFrame(animate);
    } else {
        animate();
    }

    const requestResize = function() {
        needsResize = true;
    };
    const debouncedRequestResize = _debounce(requestResize, 1500);
    window.addEventListener("resize", debouncedRequestResize);

};

</script>

<div class="container" class:rendered={hasRendered} class:hasBackgroundPage={hasBackgroundPage}>
    <div bind:this={placeholderNode}></div>
    <script id="snoise-function" type="x-shader/x-vertex">
    vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
    vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
    vec3 permute(vec3 x) { return mod289(((x*34.0)+1.0)*x); }

    float snoise(vec2 v) {
        const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0
                            0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)
                            -0.577350269189626,  // -1.0 + 2.0 * C.x
                            0.024390243902439); // 1.0 / 41.0
        vec2 i  = floor(v + dot(v, C.yy) );
        vec2 x0 = v -   i + dot(i, C.xx);
        vec2 i1;
        i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
        vec4 x12 = x0.xyxy + C.xxzz;
        x12.xy -= i1;
        i = mod289(i); // Avoid truncation effects in permutation
        vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
            + i.x + vec3(0.0, i1.x, 1.0 ));

        vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
        m = m*m ;
        m = m*m ;
        vec3 x = 2.0 * fract(p * C.www) - 1.0;
        vec3 h = abs(x) - 0.5;
        vec3 ox = floor(x + 0.5);
        vec3 a0 = x - ox;
        m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
        vec3 g;
        g.x  = a0.x  * x0.x  + h.x  * x0.y;
        g.yz = a0.yz * x12.xz + h.yz * x12.yw;
        return 130.0 * dot(m, g);
    }
    </script>
    <script id="vertex-shader" type="x-shader/x-vertex">
    uniform float u_time;
    uniform vec2 u_randomisePosition;

    varying float vDistortion;
    varying float xDistortion;
    varying vec2 vUv;

    void main() {
        vUv = uv;
        vDistortion = snoise(vUv.xx * 3. - u_randomisePosition * 0.15);
        xDistortion = snoise(vUv.yy * 1. - u_randomisePosition * 0.05);
        vec3 pos = position;
        pos.z += (vDistortion * 35.);
        pos.x += (xDistortion * 25.);

        gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
    }
    </script>
    <script id="fragment-shader" type="x-shader/x-fragment">
    vec3 rgb(float r, float g, float b) {
        return vec3(r / 255., g / 255., b / 255.);
    }
    vec3 rgb(float c) {
        return vec3(c / 255., c / 255., c / 255.);
    }
    uniform vec3 u_bg;
    uniform vec3 u_bgMain;
    uniform vec3 u_color1;
    uniform vec3 u_color2;
    uniform float u_time;

    varying vec2 vUv;
    varying float vDistortion;

    void main() {
        vec3 bg = rgb(u_bg.r, u_bg.g, u_bg.b);
        vec3 c1 = rgb(u_color1.r, u_color1.g, u_color1.b);
        vec3 c2 = rgb(u_color2.r, u_color2.g, u_color2.b);
        vec3 bgMain = rgb(u_bgMain.r, u_bgMain.g, u_bgMain.b);

        float noise1 = snoise(vUv + u_time * 0.08);
        float noise2 = snoise(vUv * 2. + u_time * 0.1);

        vec3 color = bg;
        color = mix(color, c1, noise1 * 0.6);
        color = mix(color, c2, noise2 * .4);

        color = mix(color, mix(c1, c2, vUv.x), vDistortion);

        float border = smoothstep(0.1, 0.6, vUv.x);

        color = mix(color, bgMain, 1. -border);

        gl_FragColor = vec4(color, 1.0);
    }
    </script>
</div>

<style>
.container {
    height: 100%;
    width: 100%;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
}
.container :global(#canvas),
.container :global(canvas) {
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
    height: 100% !important;
    width: 100% !important;
    opacity: 0;
    transition: opacity 1s ease-out;
}
.container.rendered :global(#canvas),
.container.rendered :global(canvas) {
    opacity: 1;
}
.container.rendered.hasBackgroundPage :global(#canvas),
.container.rendered.hasBackgroundPage :global(canvas) {
    opacity: 0.9;
}
@supports (backdrop-filter: blur(10px) brightness(0.5)) {
    .container.rendered.hasBackgroundPage :global(#canvas),
    .container.rendered.hasBackgroundPage :global(canvas) {
        opacity: 0.5;
    }
}
</style>
